import { useState, useEffect } from 'react';
import { adminApi, ensureArray } from '../services/api';

interface AuditEntry {
  id: string;
  actorId: string;
  action: string;
  targetType: string;
  targetId: string;
  payloadDiff?: unknown;
  ipAddress: string;
  createdAt: string;
}

export function AuditLogPage() {
  const [logs, setLogs] = useState<AuditEntry[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  useEffect(() => {
    adminApi<AuditEntry[]>('/admin/audit-logs')
      .then((data) => setLogs(ensureArray(data)))
      .catch((err) => {
        setLogs([]);
        setError((err as Error).message || 'Failed to load audit logs');
      })
      .finally(() => setLoading(false));
  }, []);

  if (loading) return <div className="text-center text-gray-500">Loading...</div>;

  return (
    <div>
      <h1 className="text-2xl font-bold text-gray-900">Audit Log</h1>
      {error && <p className="mt-2 text-sm text-red-600">{error}</p>}
      <div className="mt-6 overflow-x-auto">
        <table className="w-full text-left text-sm">
          <thead>
            <tr className="border-b text-gray-600">
              <th className="pb-3 pr-4 font-medium">Timestamp</th>
              <th className="pb-3 pr-4 font-medium">Actor</th>
              <th className="pb-3 pr-4 font-medium">Action</th>
              <th className="pb-3 pr-4 font-medium">Target</th>
              <th className="pb-3 font-medium">IP</th>
            </tr>
          </thead>
          <tbody>
            {logs.map((log) => (
              <tr key={log.id} className="border-b border-gray-100">
                <td className="py-3 pr-4 text-gray-500">
                  {new Date(log.createdAt).toLocaleString()}
                </td>
                <td className="py-3 pr-4 font-mono text-xs">{log.actorId.slice(0, 8)}…</td>
                <td className="py-3 pr-4">{log.action}</td>
                <td className="py-3 pr-4 text-gray-600">
                  {log.targetType}:{log.targetId.slice(0, 8)}…
                </td>
                <td className="py-3 text-gray-500">{log.ipAddress}</td>
              </tr>
            ))}
            {logs.length === 0 && !error && (
              <tr>
                <td colSpan={5} className="py-8 text-center text-gray-400">
                  No audit entries yet.
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
}
